export const SET_PARTNER_CATEGORY = 'PARTNER_CATEGORY/SET_PARTNER_CATEGORY'
export const SET_PARTNER_CATEGORIES = 'PARTNER_CATEGORY/SET_PARTNER_CATEGORIES'
